import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from '@mui/material';
import './SkeletonLoader.css';

export const TableSkeleton = () => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="skeleton table">
        <TableHead
          sx={{
            backgroundColor: '#EEF4FF',
            '& th': {
              color: 'var(--Text, #14171F)',
              height: '25px',
              fontFamily: 'Poppins',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: 'normal',
              padding: '10px 16px',
            },
          }}
        >
          <TableRow>
            <TableCell> </TableCell>
            <TableCell align="left"> </TableCell>
            <TableCell align="left"></TableCell>
            <TableCell align="left"></TableCell>
            <TableCell align="left"></TableCell>
            <TableCell align="left"></TableCell>
            <TableCell align="left"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(10)].map((_, index) => (
            <TableRow key={index}>
              <TableCell>
                <Box className="flex items-center gap-3">
                  <div className="skeleton-avatar"></div>
                  <div className="skeleton-text"></div>
                </Box>
              </TableCell>
              <TableCell align="left">
                <div className="skeleton-text"></div>
              </TableCell>
              <TableCell align="left">
                <div className="skeleton-text"></div>
              </TableCell>
              <TableCell align="left">
                <div className="skeleton-text"></div>
              </TableCell>
              <TableCell align="left">
                <div className="skeleton-text"></div>
              </TableCell>
              <TableCell align="left">
                <div className="skeleton-text"></div>
              </TableCell>
              <TableCell align="left">
                <div className="skeleton-text"></div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const ProfileSkeleton = () => {
  return (
    <div className="settings-container">
      <div className="profile-section">
        <div className="profile-image-container">
          <div className="profile-image-skeleton"></div>
        </div>
        <div className="edit-button-skeleton"></div>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <div className="skeleton-label"></div>
          <div className="skeleton-input"></div>
        </div>

        <div className="form-group">
          <div className="skeleton-label"></div>
          <div className="skeleton-input"></div>
        </div>

        <div className="form-group">
          <div className="skeleton-label"></div>
          <div className="skeleton-input"></div>
        </div>

        <div className="form-group">
          <div className="skeleton-label"></div>
          <div className="skeleton-input"></div>
        </div>

        <div className="form-group">
          <div className="skeleton-label"></div>
          <div className="skeleton-input"></div>
        </div>

        <div className="form-group">
          <div className="skeleton-label"></div>
          <div className="skeleton-input"></div>
        </div>

        <div className="form-group">
          <div className="skeleton-label"></div>
          <div className="skeleton-input"></div>
        </div>
      </div>
    </div>
  );
};

// Reusable analytics skeletons
export const CardSkeleton = () => (
  <Box sx={{ minHeight: 100, p: 2 }}>
    <div className="skeleton-text" style={{ width: '60%', height: 18, marginBottom: 8 }} />
    <div className="skeleton-text" style={{ width: '40%', height: 32, marginBottom: 8 }} />
    <div className="skeleton-text" style={{ width: '80%', height: 14 }} />
  </Box>
);

export const DonutSkeleton = () => (
  <Box
    sx={{
      minHeight: 400,
      maxHeight: 450,
      p: 2.5,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    }}
  >
    <div className="skeleton-text" style={{ width: '50%', height: 18, margin: '0 auto 16px' }} />
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 240,
      }}
    >
      <div className="skeleton-text" style={{ width: 220, height: 220, borderRadius: '50%' }} />
    </Box>
    <Box sx={{ paddingTop: 1 }}>
      <div className="skeleton-text" style={{ width: '60%', height: 16, margin: '16px auto 0' }} />
    </Box>
  </Box>
);

export const ChartSkeleton = () => (
  <Box sx={{ minHeight: 300, p: 2 }}>
    <div className="skeleton-text" style={{ width: '30%', height: 24, marginBottom: 16 }} />
    <div className="skeleton-text" style={{ width: '100%', height: 220, borderRadius: 8 }} />
  </Box>
);
